// Public API for assembling OH emails. Returns { subject, text, html } per
// template. UI code should always call composers, not the raw builders.

import {
  buildSchedulingSellerEmail,
  buildSchedulingAgentEmail,
  buildUpdateSellerEmail,
  buildUpdateAgentEmail,
  buildCancellationSellerEmail,
  buildCancellationAgentEmail,
  buildRecapSellerEmail,
} from "./openHouseEmails";

import {
  buildSchedulingSellerEmailHtml,
  buildSchedulingAgentEmailHtml,
  buildUpdateSellerEmailHtml,
  buildUpdateAgentEmailHtml,
  buildCancellationSellerEmailHtml,
  buildCancellationAgentEmailHtml,
  buildRecapSellerEmailHtml,
} from "./openHouseEmailsHtml";

export function composeSchedulingSellerEmail(oh, sender, overrides) {
  const { subject, body: text } = buildSchedulingSellerEmail(oh, overrides);
  const html = buildSchedulingSellerEmailHtml(oh, sender, overrides);
  return { subject, text, html };
}

export function composeSchedulingAgentEmail(oh, sender, origin, overrides) {
  const { subject, body: text } = buildSchedulingAgentEmail(oh, origin, overrides);
  const html = buildSchedulingAgentEmailHtml(oh, sender, origin, overrides);
  return { subject, text, html };
}

export function composeUpdateSellerEmail(oh, oldFields, newFields, sender, overrides) {
  const { subject, body: text } = buildUpdateSellerEmail(oh, oldFields, newFields, overrides);
  const html = buildUpdateSellerEmailHtml(oh, oldFields, newFields, sender, overrides);
  return { subject, text, html };
}

export function composeUpdateAgentEmail(oh, oldFields, newFields, sender, origin, overrides) {
  const { subject, body: text } = buildUpdateAgentEmail(oh, oldFields, newFields, origin, overrides);
  const html = buildUpdateAgentEmailHtml(oh, oldFields, newFields, sender, origin, overrides);
  return { subject, text, html };
}

export function composeCancellationSellerEmail(oh, reason, sender, overrides) {
  const { subject, body: text } = buildCancellationSellerEmail(oh, reason, overrides);
  const html = buildCancellationSellerEmailHtml(oh, reason, sender, overrides);
  return { subject, text, html };
}

export function composeCancellationAgentEmail(oh, reason, sender, overrides) {
  const { subject, body: text } = buildCancellationAgentEmail(oh, reason, overrides);
  const html = buildCancellationAgentEmailHtml(oh, reason, sender, overrides);
  return { subject, text, html };
}

export function composeRecapSellerEmail(oh, fb, sender, overrides) {
  const { subject, body: text } = buildRecapSellerEmail(oh, fb, overrides);
  const html = buildRecapSellerEmailHtml(oh, fb, sender, overrides);
  return { subject, text, html };
}

// Invite-resend uses the same content as the scheduling-agent email.
export function composeInviteResendEmail(oh, sender, origin, overrides) {
  return composeSchedulingAgentEmail(oh, sender, origin, overrides);
}
